import { addSeconds, differenceInSeconds, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useCommonStore } from '@/store/commonStore';

import { ScUserSessionTimer, ScUserSessionTimerProps } from './styled';

export const UserSessionTimer: FC<ScUserSessionTimerProps> = ({ isMobile }) => {
  const { t } = useTranslation();
  const user = useCommonStore.use.user();

  const { bonusTerms } = useTheme();

  const signInMoment = useMemo(() => {
    if (!user?.currentSignInAt) return 0;
    return new Date(user.currentSignInAt);
  }, [user]);

  const now = new Date();

  const initialSeconds = differenceInSeconds(now, signInMoment);

  const [seconds, setSeconds] = useState(initialSeconds);

  const formatedTime = useMemo(() => {
    const duration = addSeconds(new Date(0), seconds);
    return format(toZonedTime(duration, 'UTC'), 'HH:mm:ss');
  }, [seconds]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [user]);

  return (
    <ScUserSessionTimer isMobile={isMobile}>
      <div className="timer-wrapper">
        <bonusTerms.frequency.component />
        <span>{t('sessionTime')}</span>
        <span className="timer">{formatedTime}</span>
      </div>
    </ScUserSessionTimer>
  );
};
